import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { BlobResponse } from '../../Models/OtherClasses';

@Injectable()
export class CustomerAccountService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('CustomerAccount');
	}

	DownloadRates(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/' + (id ?? '') + '/DownloadRates');
	}


	loadAll(active: boolean): Observable<TooBig4Car.Logic.CustomerAccount[]> {
		return this.myBaseService.loadAll(this.url + '?active=' + (active ?? true).toString());
	}
	loadAllForSource(id: System.Guid): Observable<TooBig4Car.Logic.CustomerAccount[]> {
		return this.myBaseService.loadAll(this.url + '/ForSource/' + (id || ''));
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase): Observable<TooBig4Car.Logic.CustomerAccount> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.CustomerAccount> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<TooBig4Car.Logic.CustomerAccount> {
		return this.myBaseService.get(id, this.url);
	}
	toggleAccess(id: System.Guid): Observable<TooBig4Car.Logic.CustomerAccount> {
		return this.myBaseService.post(null, this.url + '/ToggleAccess/'+ (id ?? ''), true);
	}
	search(searchTerm: string): Observable<TooBig4Car.Logic.CustomerAccount[]> {
		return this.searchFullResults(searchTerm, false);
	}
	searchFullResults(searchTerm: string, fullResults: boolean): Observable<TooBig4Car.Logic.CustomerAccount[]> { 
		return this.myBaseService.post(searchTerm, this.url + '/Search?fullReturn=' + (fullResults ?? false).toString() +'&onlyMaster=' + false.toString(), false);
	}
	searchMaster(searchTerm: string): Observable<TooBig4Car.Logic.CustomerAccount[]> {
		return this.myBaseService.post(searchTerm, this.url + '/Search?fullReturn='+ false.toString() +'&onlyMaster=' + true.toString(), false);
	}
	getOverallSettings(id: System.Guid, withNulls: boolean): Observable<TooBig4Car.Logic.CustomerAccountOverallSettingsVM> {
		return this.myBaseService.getWithParams(id, this.url + '/OverallSettings','?withNulls=' + (withNulls ?? false).toString(), false);
	}
	saveOverallSettings(obj: TooBig4Car.Logic.CustomerAccountOverallSettingsVM): Observable<string> {
		return this.myBaseService.post(obj, this.url + '/OverallSettings', true);
	}

	getDeliveryZones(id: System.Guid): Observable<TooBig4Car.Logic.CustomerAccountDeliveryZonesVM> {
		return this.myBaseService.get(id, this.url + '/DeliveryZones');
	}
	saveDeliveryZones(obj: TooBig4Car.Logic.CustomerAccountDeliveryZonesVM): Observable<string> {
		return this.myBaseService.post(obj, this.url + '/DeliveryZones', true);
	}
}

